import { MOUSE_ZOOM_SENSIBILITY_WEIGHT, ZOOM_DAMPENING_WEIGHT } from '@modules/tourdanji/src/Constants';

import { clamp } from '../../util/Util';
import { MouseWheelBase } from '../data';
import { ZEDCamera } from '../ZEDCamera';
import { InputCanvasProps } from '../ZEDCameraInputManager';

export const MouseWheelZoom: MouseWheelBase & {
  option: {
    inertia: number;
    sensibility: number;
    radiusDampening: number;
  };
} = {
  type: 'MouseWheel',
  touchCount: 0,
  key: 'MouseWheelZoom',
  name: 'MouseWheelZoom',
  option: {
    mouseButton: 'all',
    mouseKeyCode: 'none',
    inertia: 0.7,
    sensibility: 0.001,
    radiusDampening: 0,
  },
  attachControl(
    _camera: ZEDCamera,
    _canvasProps: InputCanvasProps,
    _isMobileOrTablet: boolean,
    _noPreventDefault?: boolean | undefined
  ) {},
  detachControl(_camera: ZEDCamera, _isMobileOrTablet: boolean) {},
  checkInputs(_camera: ZEDCamera) {},
  reset() {},

  onMousewheel: (camera: ZEDCamera, event: WheelEvent, _canvasProps: InputCanvasProps) => {
    if (event.deltaY === 0) return false;
    const currentRadius = camera.radius;
    const minRadius = camera.lowerRadiusLimit ?? 0;
    const maxRadius = camera.upperRadiusLimit ?? 1000;
    const baseDampening = Math.max(0, (currentRadius - minRadius) / (maxRadius - minRadius));
    const dampeningParam = MouseWheelZoom.option.radiusDampening * ZOOM_DAMPENING_WEIGHT;
    const dampeningFactor = MouseWheelZoom.option.radiusDampening === 0 
    ? 1 
    : Math.max(0.1, Math.pow(baseDampening, 2) * (1 - dampeningParam) + baseDampening * dampeningParam);

    const delta = clamp(-event.deltaY, -250, 250) * MouseWheelZoom.option.sensibility * MOUSE_ZOOM_SENSIBILITY_WEIGHT * dampeningFactor;
    const rScale = camera.getRadiusScale();
    const bScale = camera.getBetaScale();

    camera.inertia = MouseWheelZoom.option.inertia;
    camera.inertialRadiusOffset += delta * rScale;
    camera.inertialBetaOffset += delta * bScale;
    const offset = camera.computeZoomAdjustOffset(delta);
    camera.setTarget(camera.target.add(offset));

    return true;
  },
};

